export const pageView = (url, gaID) => {
  window.gtag('config', `${gaID}`, {
    page_path: url,
  })
}

export const event = ({ action, params }) => {
  window.gtag('event', action, params)
}